<section class="user-details center-layout">
  <div class="form-central__content">
    <div class="form-central__form">
      <div class="logo-wrapper">
        <img src="../../../../../assets/images/rexpay.svg" alt="Rexpay logo" />
      </div>
      <p class="mt-3">Provide your details to continue to payment.</p>
      <form class="user-details-form" [formGroup]="planDetailsForm">
        <div class="row">
          <div class="row-col__md-6">
            <input
              type="text"
              class="form__control firstName name-input"
              placeholder="First Name"
              formControlName="firstName"
            />
          </div>
          <div class="row-col__md-6">
            <input
              type="text"
              class="form__control name-input"
              placeholder="Last Name"
              formControlName="lastName"
            />
          </div>
        </div>
        <div class="mb-4 user-input">
          <input
            type="email"
            class="form__control"
            placeholder="Email Address"
            formControlName="subscriberEmail"
          />
        </div>
        <div class="mb-4 user-input">
          <input
            type="tel"
            class="form__control"
            placeholder="Phone Number"
            formControlName="phoneNumber"
            (keydown)="onlyNumbers($event)"
          />
        </div>
        <div class="mb-4 user-input">
          <input
            type="text"
            class="form__control"
            placeholder="Billing Address"
            formControlName="address"
          />
        </div>
        <button
          [disabled]="planDetailsForm.invalid"
          class="btn btn__primary no-margin user-input"
          (click)="moveToPayment()"
        >
          Next
        </button>
      </form>

      <div
        class="footer"
        style="margin-top: 3rem; text-align: center; font-size: 12px"
      >
        Powered By:
        <img width="50" src="../../../assets/rexpay/ga.png" />
      </div>
    </div>
  </div>
</section>

<app-error-dialog
  [visible]="showModal"
  [message]="errorMessage"
  (closed)="showModal = false"
></app-error-dialog>
